import jquery from 'jquery';

import EFOcats_submit from '../../../core/v1/submit/efocats_submit';

/**
 * データ送信機能
 */
export default class EFOcats_retro_submit extends EFOcats_submit {
  /**
   * コンストラクタ
   */
  constructor() {
    super();
    this.submitbtn_query = 'input[type="submit"]';
  }

  /**
   * 項目作成
   */
  data_label_first() {
    this.$('.qa').each((index, element) => {
      const label = {};

      // 複数name修正（）
      // タイトル作成
      label.title = jquery(element).find('.cat-page-title').text();
      const inputs = jquery(element).find('input,textarea,select');

      label.name = '';

      for (let inputIndex = 0; inputIndex < inputs.length; inputIndex++) {
        const input = inputs.eq(inputIndex);
        if (input.attr('name')) {
          label.name = input.attr('name');
          break;
        }
      }

      label.error = [];
      label.status = this.data_label_first_status(inputs);
      label.time = 0;
      this.analy_data.labeldata.push(label);
    });
  }

  /**
   * 一問一答の処理（チェックボックスとラジオ以外）
   * @param {*} formName
   */
  create_answer_other(formName, inputelem) {
    const text = jquery(inputelem).parents('.qa').find('.cat-page-title').text();

    if (text && text.indexOf('住所') !== -1) {
      // 郵便番号
      if (formName === 'your-address2') {
        const val = this.$(`[name="${formName}"]`).val() + this.$('[name="your-address3"]').val();
        jquery(`[name="${formName}"]`).val(val);
      } else {
        jquery(`[name="${formName}"]`).val(this.$(`[name="${formName}"]`).val());
      }
    } else {
      jquery(`[name="${formName}"]`).val(this.$(`[name="${formName}"]`).val());
    }
  }

  /**
   * 一問一答の処理（チェックボックス）
   * @param {*} formName
   * @param {*} inputelem
   */
  create_answer_checkbox(formName, inputelem) {
    this.$(`input[name="${formName}"][type="checkbox"]`).each(() => {
      jquery(`input[name="${formName}"][value="${jquery(inputelem).val()}"]`)
        .prop('checked', jquery(inputelem).prop('checked'))
        .change();
    });
  }

  /**
   * 送信データ送信
   */
  send_submitdata() {
    // ページ離脱のアラートをOFFにする
    jquery(window).off('.attention');

    this.form_data.post = '';

    if (navigator.sendBeacon) {
      const data = new FormData();

      data.append('post', this.form_data.post);
      data.append('analytics', this.form_data.analytics);
      data.append('device', this.form_data.device);
      data.append('ID', this.form_data.ID);
      data.append('formID', this.form_data.formID);
      const res = navigator.sendBeacon('https://formcats.com/accept/accept.php', data);

      if (res) {
        this.success_submitdata();
      } else {
        this.fail_submitdata();
      }
    } else {
      jquery
        .ajax({
          url: 'https://formcats.com/accept/accept.php',
          type: 'post',
          dataType: 'json',
          data: this.form_data,
          contentType: false,
          processData: false,
        })
        .done((data, textStatus, jqXHR) => this.success_submitdata(data, textStatus, jqXHR))
        .fail((jqXHR, textStatus, errorThrown) => this.fail_submitdata(jqXHR, textStatus, errorThrown));
    }
  }

  /**
   * 送信成功時の処理
   */
  success_submitdata(a, b, c) {
    // jquery('.efo-cat-main').css('display', 'none');
    // // this.$('.efo-cat-main').css('display', 'none');
    // 離脱時の分析送信イベントを削除
    jquery(window).off('beforeunload.attention');

    const $ = require('jquery');
    require('jquery.cookie');
    $.cookie('submit', 'success', {
      expires: 31,
    });

    // 送信ボタンクリック
    const btn = $(this.submitbtn_query);
    btn.removeAttr('disabled');
    btn.click();
  }
}
